/**
 * Core
 */
import Vue from 'vue';
import Router from 'vue-router';

/**
 * Views
 */
import Dashboard from './views/Dashboard/Dashboard.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Splashscreen from './views/SplashScreen.vue';
import Users from './views/Users.vue';
import Suppliers from './views/Suppliers.vue';
import Products from './views/Products.vue';
import Vacations from './views/Vacations';
import Customer from './views/customer/Customer.vue';
import Orders from './views/Orders/Orders.vue';
import OrdersRemoved from './views/Orders/OrdersRemoved.vue';
import Payments from './views/Payments/Payments.vue';
import Settlements from './views/Settlements/Settlements.vue';
import InnerSummary from './views/Summary/InnerSummary.vue';
import Categories from './views/Categories.vue';
import ProductWaste from './views/ProductWaste.vue';
import RouteTemplates from './views/Routes/RouteTemplates.vue';
import PriceLists from './views/PriceLists/PriceLists.vue';

/**
 * Subviews
 */
import NoPermissions from './views/NoPermissions.vue';
import UserForm from './components/forms/UserForm.vue';
import SuppliersForm from './components/forms/SuppliersForm.vue';
import ProductsForm from './components/forms/ProductsForm.vue';
import VacationsForm from './components/forms/VacationsForm.vue';
import CustomersForm from './components/forms/customers/CustomersForm.vue';
import OrdersForm from './components/forms/orders/OrdersForm.vue';
import CategoriesForm from './components/forms/CategoriesForm.vue';
import ProductGroups from './views/ProductGroups.vue';
import ProductGroupsForm from './components/forms/ProductGroupsForm.vue';
import PriceListsForm from './components/forms/priceLists/PriceListsForm.vue';

/**
 * Helpers
 */
import SanitizeUtils from './utils/SanitizeUtils';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [

    {
      path: '/logowanie', component: Login, name: 'Logowanie', meta: { layout: 'guest' }
    },
    { path: '/wyloguj', component: Logout, name: 'Wyloguj' },
    { path: '/wczytywanie', component: Splashscreen, name: 'Splashscreen' },
    { path: '/', redirect: '/kokpit' },
    { path: '/kokpit', component: Dashboard, name: 'Kokpit' },
    { path: '/uzytkownicy', component: Users, name: 'Użytkownicy' },
    { path: '/uzytkownicy/nowy', component: UserForm, name: 'Dodawanie Użytkownika' },
    { path: '/uzytkownicy/edycja/:id', component: UserForm, name: 'Edycja użytkownika' },
    { path: '/dostawcy', component: Suppliers, name: 'Dostawcy' },
    { path: '/dostawcy/nowy', component: SuppliersForm, name: 'Dodawanie Dostawcy' },
    { path: '/dostawcy/edycja/:id', component: SuppliersForm, name: 'Edycja Dostawcy' },
    { path: '/produkty', component: Products, name: 'Produkty' },
    { path: '/produkty/nowy', component: ProductsForm, name: 'Dodawanie Produktu' },
    { path: '/produkty/edycja/:id', component: ProductsForm, name: 'Edycja Produktu' },
    { path: '/urlopy', component: Vacations, name: 'Urlopy' },
    { path: '/urlopy/nowy', component: VacationsForm, name: 'Dodawanie Urlopu' },
    { path: '/urlopy/edycja/:id', component: VacationsForm, name: 'Edycja Urlopu' },
    { path: '/kategorie', component: Categories, name: 'kategorie' },
    { path: '/kategorie/nowy', component: CategoriesForm, name: 'Dodawanie kategorii' },
    { path: '/kategorie/edycja/:id', component: CategoriesForm, name: 'Edycja kategorii' },
    { path: '/grupy-produktowe', component: ProductGroups, name: 'Grupy produktowe' },
    { path: '/grupy-produktowe/nowy', component: ProductGroupsForm, name: 'Dodawanie grupy produktowej' },
    { path: '/grupy-produktowe/edycja/:id', component: ProductGroupsForm, name: 'Edycja grupy produktowej' },
    { path: '/cenniki', component: PriceLists, name: 'Cenniki wzorcowe' },
    { path: '/cenniki/nowy', component: PriceListsForm, name: 'Dodawanie cennika' },
    { path: '/cenniki/edycja/:id', component: PriceListsForm, name: 'Edycja cennika' },
    { path: '/klienci', component: Customer, name: 'Klienci' },
    { path: '/klienci/nowy', component: CustomersForm, name: 'Dodawanie Klienta' },
    { path: '/klienci/edycja/:id', component: CustomersForm, name: 'Edycja Klienta' },
    { path: '/zamowienia', component: Orders, name: 'Zamówienia' },
    { path: '/zamowienia-wewnetrzne', component: InnerSummary, name: 'Zamówienia wewnętrzne' },
    { path: '/zamowienia/nowy', component: OrdersForm, name: 'Dodawanie Zamówienia' },
    { path: '/zamowienia/edycja/:id', component: OrdersForm, name: 'Edycja Zamówienia' },
    { path: '/zamowienia-usuniete', component: OrdersRemoved, name: 'Usunięte zamówienia' },
    { path: '/wplaty', component: Payments, name: 'Historia płatności' },
    { path: '/rozliczenia', component: Settlements, name: 'Dział Rozliczeń' },
    { path: '/raport-odpadu', component: ProductWaste, name: 'Raport odpadu' },
    { path: '/szablony-tras', component: RouteTemplates, name: 'Szablony tras' },
    { path: '/404', component: Errors },
    { path: '/brak-uprawnien', component: NoPermissions },
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Wyloguj'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  next();
});

export default router;
